// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__3Z9z8","spinner":"Spinner_spinner__3OSGK","spin":"Spinner_spin__18T1t"};